import { updateGlobalEntities } from '.';
import { addExpirationDate, calculateApportionment, isValidApplyApportionment } from '../../utils/products';
import { selectProductsEntities } from '../selectors/bootstrap';
import { selectActivePlanSubscription } from '../selectors/products';
import { selectShoppingCartConfig } from '../selectors/shoppingCart';


/**
 * Handles updating shoppingCart entity with
 * user's selected product
 *
 * @param {string} payload
 * @returns {function(*, *): Promise}
 */
export const addProduct = (payload) => {
  return (dispatch, getState) => {
    const shoppingCart = selectShoppingCartConfig(getState());
    const mainSubscription = selectActivePlanSubscription(getState());
    const products = selectProductsEntities(getState());
    const { applyApportionment } = payload;
    const { productsToBuy } = shoppingCart || { productsToBuy: [] };
    let updatedProducts;
    let productWithPrices = payload;
    if (!productWithPrices.priceToShow) productWithPrices = products?.find(product => product.productID === payload.productID);
    if (applyApportionment) {
      const { newPrice, daysDifference } = calculateApportionment(addExpirationDate(payload), mainSubscription);
      const isValidApply = isValidApplyApportionment({ newPrice, daysDifference });
      if (isValidApply) {
        payload.applyApportionment = true;
        payload.discountPrice = newPrice;
        payload.daysDifference = daysDifference;
      }
    }

    if (productsToBuy?.length) {
      const indexProduct = productsToBuy.findIndex(product => product.productID === payload.productID);
      if (indexProduct === -1) {
        updatedProducts = [...productsToBuy, payload]
      } else {
        updatedProducts = productsToBuy.filter(product => product.productID !== payload.productID);
      }
    }

    return dispatch(updateGlobalEntities({
      shoppingCart: {
        ...shoppingCart,
        productsToBuy: productsToBuy?.length ? updatedProducts : [payload]
      }
    }));
  };
};

export const setAddOnsToShow = (payload) => {
  return (dispatch, getState) => {
    const shoppingCart = selectShoppingCartConfig(getState());
    return dispatch(updateGlobalEntities({
      shoppingCart: {
        ...shoppingCart,
        addOnsToShow: payload
      },
    }));
  };
}

export const cleanOrder = () => {
  return (dispatch, getState) => {
    const shoppingCart = selectShoppingCartConfig(getState());
    return dispatch(updateGlobalEntities({
      shoppingCart: {
        ...shoppingCart,
        productsToBuy: undefined,
        addOnsToShow: []
      },
      couponApply: undefined
    }));
  };
};
